<template>
  <el-form label-width="80px" :model="formmodel">
    <el-form-item label="appid "><el-input v-model="formmodel.name" @input="changeFunc"></el-input></el-form-item>
    <el-form-item label="页面路径 "><el-input v-model="formmodel.url" @input="changeFunc"></el-input></el-form-item>
    <el-form-item label="">
      <p>注意一：同一个小程序链接其他小程序，最多只能链接10个，超过将不生效</p>
      <p>注意二：不能填写自身小程序appid</p>
      <p>注意三：小程序链接留空默认跳到小程序首页</p>
    </el-form-item>
  </el-form>
</template>

<script>
  export default{
    data(){
      return {
        /*form模型*/
        formmodel: {
          name:'',
          url:''
        }
      }
    },
    methods:{
      /*选中的值*/
      changeFunc(e){
        let self = this;
        let params = {};

        params.type = "小程序";
        params.appid = self.formmodel.name;
        params.name = self.formmodel.name;
        params.url = self.formmodel.url;
        this.$emit('changeData',params);
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/SmallProgram.vue